module.exports = __webpack_public_path__ + "static/media/x.fdd468ce.svg";